"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _underscore = require("underscore");

var _universe = _interopRequireDefault(require("../../assets/universe.svg"));

var _ccg = _interopRequireDefault(require("../../assets/ccg.svg"));

var _search = _interopRequireDefault(require("../../assets/icons/search.svg"));

var _marker = _interopRequireDefault(require("../../assets/icons/marker.svg"));

var _hamburger = _interopRequireDefault(require("../../assets/icons/hamburger.svg"));

var _navbarLink = _interopRequireDefault(require("./navbar-link"));

var _userDropdown = _interopRequireDefault(require("./user-dropdown"));

var _hostDropdown = _interopRequireDefault(require("./host-dropdown"));

var _helpDropdown = _interopRequireDefault(require("./help-dropdown"));

var _userDrawer = _interopRequireDefault(require("./user-drawer"));

var _searchPanel = _interopRequireDefault(require("./search-panel"));

var _cityInput = _interopRequireDefault(require("./city-input"));

var _searchField = _interopRequireDefault(require("../search-field"));

var _responsive = require("../responsive");

var _reactIntl = require("react-intl");

var _intlFormat = require("../../lib/intl-format");

var _translations = _interopRequireDefault(require("./translations"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Navbar,
    boundMethodCheck = function boundMethodCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new Error('Bound instance method accessed before binding');
  }
};

var _default = (0, _intlFormat.withTranslations)(_translations.default, Navbar = function () {
  var ref;

  var Navbar =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Navbar, _React$Component);

    function Navbar(props) {
      var _this;

      _classCallCheck(this, Navbar);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Navbar).apply(this, arguments)); // actions

      _this.recalcStuck = _this.recalcStuck.bind(_assertThisInitialized(_this));
      _this.onNavigate = _this.onNavigate.bind(_assertThisInitialized(_this));
      _this.toggleDrawer = _this.toggleDrawer.bind(_assertThisInitialized(_this));
      _this.toggleSearch = _this.toggleSearch.bind(_assertThisInitialized(_this));
      _this.onSearch = _this.onSearch.bind(_assertThisInitialized(_this));
      _this.switchLocale = _this.switchLocale.bind(_assertThisInitialized(_this));
      _this.logo = _this.logo.bind(_assertThisInitialized(_this));
      _this.state = {
        stuck: false,
        drawerOpen: false,
        searchOpen: false
      };
      return _this;
    }

    _createClass(Navbar, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.sticky && this.props.transparent) {
          return window.onscroll = (0, _underscore.throttle)(this.recalcStuck, 50);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        return window.onscroll = null;
      }
    }, {
      key: "recalcStuck",
      value: function recalcStuck() {
        var stuck;
        boundMethodCheck(this, Navbar);
        stuck = document.body.scrollTop > 0;

        if (this.state.stuck !== stuck) {
          return this.setState({
            stuck: stuck
          });
        }
      }
    }, {
      key: "onNavigate",
      value: function onNavigate(evt) {
        var base, ref1, ref2, t, url;
        boundMethodCheck(this, Navbar);
        t = evt.currentTarget;
        url = (t != null ? (ref1 = t.attributes) != null ? (ref2 = ref1.href) != null ? ref2.value : void 0 : void 0 : void 0) || (t != null ? t.href : void 0);

        if (typeof (base = this.props).onNavigate === "function" ? base.onNavigate(url) : void 0) {
          if (evt != null) {
            evt.preventDefault();
          }

          return true; // return true to indicate the action has been handled
        }
      }
    }, {
      key: "toggleDrawer",
      value: function toggleDrawer() {
        boundMethodCheck(this, Navbar);
        return this.setState({
          drawerOpen: !this.state.drawerOpen
        });
      }
    }, {
      key: "toggleSearch",
      value: function toggleSearch() {
        boundMethodCheck(this, Navbar);
        return this.setState({
          searchOpen: !this.state.searchOpen
        });
      }
    }, {
      key: "onSearch",
      value: function onSearch(evt) {
        var base, ref1, term;
        boundMethodCheck(this, Navbar);
        term = (evt != null ? (ref1 = evt.target) != null ? ref1.value : void 0 : void 0) || evt || '';

        if (this.props.onSearch) {
          return typeof (base = this.props).onSearch === "function" ? base.onSearch(term) : void 0;
        } else {
          return this.doSearch(term);
        }
      }
    }, {
      key: "switchLocale",
      value: function switchLocale(evt) {
        var base, ref1;
        boundMethodCheck(this, Navbar);
        return typeof (base = this.props).switchLocale === "function" ? base.switchLocale((evt != null ? (ref1 = evt.target) != null ? ref1.value : void 0 : void 0) || evt) : void 0;
      } // render funtions

    }, {
      key: "render",
      value: function render() {
        var ccg, className, shadow, sticky, stuck, transparent;
        var _this$props = this.props;
        transparent = _this$props.transparent;
        sticky = _this$props.sticky;
        shadow = _this$props.shadow;
        ccg = _this$props.ccg;
        stuck = this.state.stuck;
        className = (0, _classnames.default)('Navbar', {
          transparent: transparent,
          sticky: sticky,
          shadow: shadow,
          ccg: ccg
        }, {
          stuck: stuck
        });
        return _react.default.createElement("div", {
          className: className
        }, _react.default.createElement("div", {
          className: "container"
        }, _react.default.createElement(_responsive.Phone, {
          className: "items"
        }, this.mobileSearch(), this.logo(), this.mobileAccount()), _react.default.createElement(_responsive.Tablet, {
          className: "items"
        }, this.mobileSearch(), this.logo(), this.mobileAccount()), _react.default.createElement(_responsive.Laptop, {
          className: "items"
        }, this.logo(), this.search(), this.locale(), this.links(), this.account()), _react.default.createElement(_responsive.Desktop, {
          className: "items"
        }, this.logo(), this.search(), this.locale(), this.links(), this.account())));
      }
    }, {
      key: "logo",
      value: function logo() {
        var Logo;
        boundMethodCheck(this, Navbar);
        Logo = this.props.ccg ? _ccg.default : _universe.default;
        return _react.default.createElement("div", {
          className: "logo"
        }, _react.default.createElement("a", {
          href: "/"
        }, _react.default.createElement(Logo, null)));
      }
    }, {
      key: "search",
      value: function search() {
        var location_placeholder, search_placeholder;
        search_placeholder = this.props.intl.formatMessage({
          id: 'library.navbar.search_for_events',
          defaultMessage: 'Search for events'
        });
        location_placeholder = this.props.intl.formatMessage({
          id: 'library.navbar.enter_location',
          defaultMessage: 'Enter location'
        });
        return _react.default.createElement("div", {
          className: "search"
        }, _react.default.createElement(_searchField.default, {
          onChange: this.onSearch,
          value: this.props.search,
          placeholder: search_placeholder
        }), false ? _react.default.createElement(_cityInput.default, {
          className: "searchLocation",
          types: ['(cities)']
        }) : void 0, false ? _react.default.createElement("div", {
          className: "searchLocation"
        }, _react.default.createElement("input", {
          type: "input",
          defaultValue: "Toronto, ON",
          placeholder: location_placeholder
        }), _react.default.createElement(_marker.default, {
          className: "input-icon-left"
        })) : void 0);
      }
    }, {
      key: "locale",
      value: function locale() {
        var key, ref1, val;
        return _react.default.createElement("div", {
          className: "locale"
        }, _react.default.createElement("select", {
          className: "localeSelect",
          onChange: this.switchLocale,
          value: ((ref1 = this.props.intl) != null ? ref1.locale : void 0) || 'en'
        }, function () {
          var ref2, results;
          ref2 = this.props.locales;
          results = [];

          for (key in ref2) {
            val = ref2[key];
            results.push(_react.default.createElement("option", {
              key: key,
              value: key
            }, val));
          }

          return results;
        }.call(this)));
      }
    }, {
      key: "links",
      value: function links() {
        var ref1;
        return _react.default.createElement("div", {
          style: {
            display: 'flex',
            alignItems: 'center'
          }
        }, this.props.user == null ? _react.default.createElement(_helpDropdown.default, {
          onNavigate: this.onNavigate,
          sticky: this.props.sticky
        }) : void 0, _react.default.createElement("div", {
          className: "links"
        }, _react.default.createElement("a", {
          href: "/explore",
          onClick: this.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.find_events",
          defaultMessage: "Find Events"
        }))), ((ref1 = this.props.user) != null ? ref1.is_host : void 0) ? _react.default.createElement("div", {
          className: "links"
        }, _react.default.createElement("a", {
          href: "/create",
          onClick: this.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.create_event",
          defaultMessage: "Create Event"
        }))) : _react.default.createElement(_hostDropdown.default, {
          onNavigate: this.onNavigate,
          sticky: this.props.sticky
        }));
      }
    }, {
      key: "account",
      value: function account() {
        return _react.default.createElement("div", {
          className: "account"
        }, this.props.user != null ? _react.default.createElement(_userDropdown.default, {
          user: this.props.user,
          onNavigate: this.onNavigate
        }) : _react.default.createElement("div", {
          className: "sign-in-up"
        }, _react.default.createElement("a", {
          className: "unii-skip",
          href: "/sign-in?redirectTo=".concat(window.location.href),
          onClick: this.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.sign_in",
          defaultMessage: "Log In"
        })), _react.default.createElement("a", {
          className: "unii-skip",
          href: "/users/sign_up?redirectTo=".concat(window.location.href),
          onClick: this.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.sign_up",
          defaultMessage: "Sign Up"
        }))));
      }
    }, {
      key: "mobileAccount",
      value: function mobileAccount() {
        return _react.default.createElement("div", {
          className: "account"
        }, _react.default.createElement(_hamburger.default, {
          className: "hamburger-icon",
          onClick: this.toggleDrawer
        }), _react.default.createElement(_userDrawer.default, {
          onClose: this.toggleDrawer,
          open: this.state.drawerOpen,
          side: 'right',
          user: this.props.user,
          onNavigate: this.props.onNavigate
        }));
      }
    }, {
      key: "mobileSearch",
      value: function mobileSearch() {
        return _react.default.createElement("div", {
          className: "search"
        }, _react.default.createElement(_search.default, {
          className: "search-icon",
          onClick: this.toggleSearch
        }), _react.default.createElement(_searchPanel.default, {
          onClose: this.toggleSearch,
          open: this.state.searchOpen,
          onSearch: this.onSearch
        }));
      }
    }]);

    return Navbar;
  }(_react.default.Component);

  ;
  Navbar.propTypes = {
    user: _propTypes.default.object,
    transparent: _propTypes.default.bool,
    shadow: _propTypes.default.bool,
    sticky: _propTypes.default.bool,
    search: _propTypes.default.string,
    onSearch: _propTypes.default.func,
    onNavigate: _propTypes.default.func,
    switchLocale: _propTypes.default.func,
    locales: _propTypes.default.object
  };
  Navbar.defaultProps = {
    transparent: false,
    shadow: false,
    sticky: true,
    search: null,
    ccg: /r=CCG/i.test((typeof window !== "undefined" && window !== null ? (ref = window.location) != null ? ref.search : void 0 : void 0) || '')
  };
  Navbar.prototype.doSearch = (0, _underscore.debounce)(function (term) {
    if (term) {
      return window.location.href = "/explore?query=".concat(term.replace(/\s+/, '+'));
    }
  }, 500);
  return Navbar;
}.call(void 0));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/navbar/index.js
// module id = 1462
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16